import Vue from "vue";
import Component from "vue-class-component";
import GhBase from "@/components/ghBase";
import { Watch } from "vue-property-decorator";
import { MethodService } from "@/utils/serviceModel";
import codeComponent from "@/components/codeComponent.vue";

@Component
export default class PageTemplate extends GhBase {
    private showQuery: boolean = true;
    private keyword: string = '';
    private dataSource = { count: 0, items: [] };
    private currentItem = { template: '', js: '', css: '', service: '' };
    private isQuery: boolean = false;
    private isEdit: boolean = false;
    private page = 1;
    private pageRows = 20;
    private codeSelectedTable = "前台代码";
    private model: {} = { Id: '', Cd: '', Name: '' };
    private editMode: boolean = false;
    private editModeItem: IndexObject = {};
    private message: String = '';

    private async query() {
        this.isQuery = true;
        let res = await this.getTemplateMenuMethod.invokeAsyn({ keyword: this.keyword, page: this.page, page_rows: this.pageRows });
        if (res.data.isSuccess) {
            this.dataSource = {
                ...this.dataSource, count: res.data.data[0], items: res.data.data[1]
            };
        }
        this.isQuery = false;
    }

    private async queryCode(id: string) {
        if (id) {
            this.isEdit = true;
            this.editMode = false;
            let res = await this.getPageMethod.invokeAsyn({ id: id });
            if (res.data.isSuccess) {
                let obj = res.data.data;
                this.model = obj;
                let pageCode = obj.PageCode;
                let serviceCode = obj.ServiceCode;
                if (pageCode && serviceCode) {
                    let temp = JSON.parse(pageCode);
                    this.currentItem = {
                        ...this.currentItem, template: temp.template, js: temp.js, css: temp.css, service: serviceCode
                    };
                }
            }
            this.message = '';
            this.isEdit = false;
        }
    }

    @Watch('editMode')
    private preview() {
        if (this.editMode) {
            this.editModeItem = { ...this.currentItem };
            delete this.editModeItem.service;
        }
    }

    @Watch('currentItem.template')
    @Watch('currentItem.js')
    @Watch('currentItem.css')
    private changeState() {
        this.message = '正在编辑中...';
    }

    private async save() {
        if (this.currentItem.template == '' || this.currentItem.js == '' || this.currentItem.service == '') {
            alert('代码存在异常，请检查后再保存!')
            return;
        }
        let pagecode = { template: this.currentItem.template, js: this.currentItem.js, css: this.currentItem.css };
        let servicecode = this.currentItem.service;
        this.model = { ...this.model, PageCode: JSON.stringify(pagecode), ServiceCode: servicecode };
        this.isEdit = true;
        await this.saveModelMethod.invokeAsyn({ item: this.model });
        this.message = '已保存';
        this.isEdit = false;
    }

    private refresh() {
        let comp = this.$refs['comp'] as IndexObject;
        if (comp) {
            comp.refresh();
        }
    }

    private onCopy(id) {
        let oInput = document.createElement('input');
        oInput.value = id;
        document.body.appendChild(oInput);
        oInput.select();
        document.execCommand('Copy');
        this.$message({ message: '复制成功' });
        oInput.remove();
    }


    private getTemplateMenuMethod: MethodService = new MethodService(
        "plat.menu",
        "MenuService",
        "query_template_menus"
    );

    private getPageMethod: MethodService = new MethodService(
        "plat.page",
        "PageCodeService",
        "get"
    );

    private saveModelMethod: MethodService = new MethodService(
        "plat.page",
        "PageCodeService",
        "save"
    );
}